export function isValidEmailAddress(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function normalizeDeliveryEmail(value: string): string | null {
  const email = value.trim();
  if (email.length > 254 || !isValidEmailAddress(email)) return null;
  const split = email.lastIndexOf("@");
  let domain: URL;
  try {
    domain = new URL(`https://${email.slice(split + 1)}`);
  } catch {
    return null;
  }
  if (!domain.hostname || domain.pathname !== "/" || domain.port || domain.username || domain.password) return null;
  return `${email.slice(0, split)}@${domain.hostname}`.toLowerCase();
}
